import React, { useState, useEffect, useMemo } from "react"
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { filterdata } from "../helper/mapSearchData";


function OurComponent(props) {

    const { t, i18n } = useTranslation('common');
    const [category_data, setCatData] = useState([]);
    const [trades_data, setTradesData] = useState([]);
    const [locations_data, setLocationData] = useState([]);
    const [professionals, setProfessionalData] = useState([]);

    const [display, setDisplay] = useState(['none', 'none', 'none']);

    const [select_value1, setSelectValue1] = useState('');
    const [select_value2, setSelectValue2] = useState('');

    const [select_valueID1, setSelectValueID1] = useState('')
    const [select_valueID2, setSelectValueID2] = useState('')
    const [showGrassColor, setShowGrassColor] = useState(false)
    const [data_check, setData_check] = useState(false)
    const [data_check1, setData_check1] = useState(false)
    const [searchType, setSearchType] = useState('search_by_info')

    const [selectTrader, setSelectTrader] = useState('')
    const [selectTraderSlug, setSelectTraderSlug] = useState('')
    const [searchTypeText, setSearchTypeText] = useState('Αναζήτηση επαγγελματία ονομαστικά')
    const [toggle, setToggle] = useState(false);
    const [toggle1, setToggle1] = useState(false);
 
    const [filteredLocationData, setFilteredLocationData] = useState([]);

    React.useEffect(() => {




        if (props?.lan == 'en') {
            i18next.changeLanguage("en");
        } else {
            i18next.changeLanguage("el");
        }
    
        if (props?.version1 == 'version1' && props?.version2 == 'version2') {
            console.log("KAdnj");


        }

        jQuery(document).on('click', function (event) {
          
            if (!jQuery(event.target).closest('.filter-sec').length) {
                setToggle(false);
                setToggle1(false);
                console.log(filteredLocationData);
                  jQuery('.filter-search-result').hide();
            }
        });
        jQuery(document).on('click', '.filter-select-arrow_wrapper1', function () {
            // jQuery(this).find('.filter-select-arrow').trigger('click');
            setToggle1(false);
            var pluginUrl = props.site_url + '/wp-content/plugins';
            var items = [];
            var json_file = pluginUrl + '/brads-boilerplate-block-plugin/trade_file.json';
            jQuery.getJSON(json_file, function (data) {
                jQuery.each(data.data, function (key, val) {

                    items.push({
                        title: val.name,
                        slug: val.slug,

                    });


                });

                setTradesData(items);


            });
            jQuery(this).parent().parent().find('.filter-search-result').show();


        });
       
        jQuery(document).on('click', '.filter-select-arrow_wrapper2', function () {
            setToggle(false);
            var tradeValue = jQuery(".tradeInputData").val();

            // jQuery(this).find('.filter-select-arrow').trigger('click');
            var pluginUrl = props.site_url + '/wp-content/plugins';
            var items = [];
            if (tradeValue && tradeValue != "") {
                var button = document.querySelector('.filter-select-arrow');

                if (button) {
                    // Disable the button
                    button.disabled = false;
                }
                var url_1 = props.site_url + '/wp-json/myapi/v1/get_location_val?trade=' + tradeValue;

               

                jQuery(this).parent().parent().find('.filter-search-result').show();
                // }
            } else {
                var button = document.querySelector('.filter-select-arrow');

                if (button) {
                    // Disable the button
                    button.disabled = true;
                }
              
            }
            


        });
     
        const trade_selected = props?.trade_name ? props?.trade_name : '';
        setSelectValueID2(trade_selected);
     
        setSelectValue2(props?.Dtrade_name ? props?.Dtrade_name : '');

       
        const location_selected = props?.location_name ? props?.location_name : '';
        setSelectValueID1(location_selected);
        //  setLocationData(props?.location_data?.data);
        setSelectValue1(props?.Dlocation_name ? props?.Dlocation_name : '');

        // setProfessionalData(props?.professionals);
        // console.log(props?.professionals);
    }, []);

    async function open_drop_down(e) {
        const index = e.target.getAttribute("data-index");
        let data = [];
        data[0] = data[1] = data[2] = 'none';
        data[index] = 'block';
        setDisplay(data);
    }

    function redirect_tosearch_page1() {
        //

        if (select_valueID2 && select_valueID1) {
            const url = props.site_url + (props?.lan ? '/' + props?.lan : '') + "/" + (select_valueID2 ? select_valueID2 : '') + '/' + (select_valueID1 ? select_valueID1 : '') + "/";
            window.location.href = url;
        }

    }
    function redirect_tosearch_page2() {
        if (selectTrader) {
            window.location.href = props.site_url + (props?.lan ? '/' + props?.lan : '') + "/" + selectTraderSlug;
        }
    }
    function update_select_value(e) {
        select_value[e.index] = e.value;
        setSelectValue(select_value);
    }

    function setInputValue(e) {
        setToggle(false);
        setToggle1(false);

        const index = e.target.getAttribute("data-index");
        const value = e.target.getAttribute("data-label");
        const valueID = e.target.getAttribute("data-value");

        if (index == 0) {
            setSelectValue1(value);
            setSelectValueID1(valueID);
        }
        if (index == 1) {
            setSelectValue2(value);
            setSelectValueID2(valueID);
        } if (index == 2) {
            setSelectTrader(value);
            setSelectTraderSlug(valueID);
        }
        jQuery('.filter-search-result').hide();
        const target = e.target.getAttribute("data-target");
        if (target == 'traderData') {
            var url_1 = props.site_url + '/wp-json/myapi/v1/get_location_val?trade=' + value;
            if (url_1) {
                var data = axios.get(url_1).then((response) => {
                    setFilteredLocationData(response);
                    var items = [];
                    jQuery.each(response.data.data, function (key, val) {
                        jQuery.each(val, function (key, location_val) {
                            items.push({
                                title: location_val.name,
                                slug: location_val.slug,
                                parent: location_val.parent,

                            });
                        });

                    });
                    if (items || items != []) {
                        setLocationData(items);
                    }
                });
            }
        }
    }

    function open_dropDown1() {
        jQuery('.filter_1').show()
        var pluginUrl = props.site_url + '/wp-content/plugins';
        var items = [];
        var json_file = pluginUrl + '/brads-boilerplate-block-plugin/trade_file.json';
        jQuery.getJSON(json_file, function (data) {
            jQuery.each(data.data, function (key, val) {

                items.push({
                    title: val.name,
                    slug: val.slug,

                });


            });

            setTradesData(items);


        });


    }

    async function open_dropDown2() {
        
        var tradeValue = jQuery(".tradeInputData").val();
        if (tradeValue == '') {
            var button = document.querySelector('.filter-select-arrow');

            if (button) {
                
                button.disabled = true;
            }
        } else {
            var button = document.querySelector('.filter-select-arrow');

            if (button) {
               
                button.disabled = false;
            }
        }

    }

    function toggle_search_fields() {
        if ('search_by_name' == searchType) {
            setSearchTypeText('Αναζήτηση επαγγελματία ονομαστικά');
            setSearchType('search_by_info');
            // jQuery('.search_by_name').hide();
            // jQuery('.search_by_info').show();
            jQuery('.search_by_info_all').show();
            jQuery('.search_by_Pname').hide();
        } else {
            setSearchTypeText('Αναζήτηση επαγγελματία με ειδικότητα');
            setSearchType('search_by_name');
            // jQuery('.search_by_info').hide();
            // jQuery('.search_by_name').show();
            jQuery('.search_by_info_all').hide();
            jQuery('.search_by_Pname').show();
        }
    }
    
    async function filterTradersData(obj) {

        jQuery('.filter-search-result').hide();
        jQuery(obj.target).parent().find('.filter-search-result').show();

        // console.log(jQuery(obj.target).parent().find('.filter-search-result').attr('style','display:block !important'));
        const data = await filterdata('trader', 'professionals_file.json');
        // console.log(data);
        setProfessionalData(data);
    }

    async function filterTradeData(obj) {
        setToggle(true);

     
        jQuery(obj.target).parent().find('.filter-search-result').show();
         var search_val = obj.target.value;

        var search_data = JSON.stringify(search_val);
        
        const data = await filterdata('trade', 'trade_file.json');
        //alert(data);
        console.log(data);
        setTradesData(data);

    }
    async function filterLocationData(obj) {
        setToggle1(true);
        jQuery('.filter-search-result').hide();
        jQuery(obj.target).parent().find('.filter-search-result').show();
       
        const data = await filterdata('location', 'location_file.json', filteredLocationData);
        setLocationData(data);


    }
    async function toggleLocationResultBox() {
        setToggle1(!toggle1);
        var items = [];
        console.log(filteredLocationData);
        jQuery.each(filteredLocationData.data.data, function (key, val) {
            jQuery.each(val, function (key, location_val) {
                items.push({
                    title: location_val.name,
                    slug: location_val.slug,
                    parent: location_val.parent,

                });
            });

        });
        setLocationData(items);
    }
    return (<div class="filter-container rem_search_filter" data-type="search_by_all">
        {/* <h1>{t('welcome')}</h1> */}
        {((props?.version1 && props?.version1 == 'version1') || props?.Dtrade_name || props?.Dlocation_name) ?

            <div class="filter-sec col-xl-8 col-lg-8 col-md-12 search_by_info search_all" data-type="search_by_info">
                <div class="filter-form-group " data-index="1">
                    <input type="hidden" value={props?.lan} id="current_lan" name="current_lan" />

                    <input class="tradeInputData filter-form-group-dropdown" onKeyUp={filterTradeData} onChange={e => setSelectValue2(e.target.value)} value={select_value2} type="text" placeholder={t('Trades')} autocomplete="off" />

                    <div class="filter-select-arrow_wrapper filter-select-arrow_wrapper1" onClick={() => setToggle(!toggle)}>
                        <span class="filter-select-arrow" onClick={open_dropDown1} ></span>
                    </div>


                    {toggle && (<div class="filter-search-result filter_1" >
                        <ul>
                            {trades_data.map(function (object, i) {

                                return <li data-index="1" onClick={setInputValue} data-label={object.title} data-value={object.slug}>{t(object.title)}</li>
                            })}
                        </ul>

                        {
                            trades_data.length === 0 ? (
                                <div class="no_result_found showMsg">
                                    <b>{t('No result found')}</b>
                                </div>
                            ) : (
                                <div>
                                    <b></b>
                                </div>
                            )
                        }
                    </div>
                    )}
                </div>
            </div>
            : ''
        }
        {((props?.version1 && props?.version1 == 'version1') || props?.Dtrade_name || props?.Dlocation_name) ?
            <div class="filter-sec col-xl-8 col-lg-8 col-md-12 search_by_info search_all" data-type="search_by_info">
                <div class="filter-form-group" data-index="0">
                    <input class="locationInputData filter-form-group-dropdown" onKeyUp={filterLocationData} onChange={e => setSelectValue1(e.target.value)} value={select_value1} type="text" placeholder={t('Locations')} autocomplete="off" />
                    <div class="filter-select-arrow_wrapper filter-select-arrow_wrapper2" onClick={() => setToggle1(!toggle1)}>
                        <span class="filter-select-arrow" onClick={open_dropDown2}></span>
                    </div>
                    {toggle1 && (<div class="filter-search-result filter_2">
                        <ul class="atica_child">

                            {(locations_data) ? locations_data.map(function (child_val, i) {

                                if (child_val?.parent == 0) {

                                    var data = (<li class="rem_parent_location " data-index="0" onClick={setInputValue} data-label={child_val?.title} data-value={child_val?.slug}>{child_val?.title}</li>);
                                    return data;
                                }
                                //  console.log(child_val?.title);
                                var data = (<li class="rem_child_location" data-index="0" onClick={setInputValue} data-label={child_val?.title} data-value={child_val?.slug}>{child_val?.title}</li>);
                                return data;
                            }) : ''
                            }

                        </ul>
                        {
                            locations_data.length === 0 ? (
                                <div class="no_result_found showMsg">
                                    <b>{t('No result found')}</b>
                                </div>
                            ) : (
                                <div>
                                    <b></b>
                                </div>
                            )
                        }
                    </div>
                    )}
                </div>
            </div>
            : ''
        }
        {((props?.version1 && props?.version1 == 'version1') || props?.Dtrade_name || props?.Dlocation_name) ?
            <div class="filter-sec col-1 all_btn version_1 search_by_info">
                <button onClick={redirect_tosearch_page1} class="searchfilterbtn"> Αναζήτηση</button>
            </div>
            : ''
        }
        {(props?.version2 && props?.version2 == 'version2') ?
            <div class="filter-sec col-xl-8 col-lg-8 col-md-12 search_by_name search_all" data-type="search_by_name">
                <div class="filter-form-group search-container" data-index="0">
                    <input class="traderInputData filter-form-group-dropdown" onKeyUp={filterTradersData} onChange={e => setSelectTrader(e.target.value)} value={selectTrader} type="text" placeholder={t('Ονομα επαγγελματία')} autocomplete="off" />
                    <div class="filter-search-result filter_2">
                        <ul class="atica_child ">

                            {/* {
                            console.log(professionals)
                        } */}
                            {professionals.map(function (object, i) {

                                // var professionals_data = (<il>test</il>);
                                var professionals_data = (<li class="rem_parent_location " onClick={setInputValue} data-index="2" data-label={object?.title} data-value={object?.slug}>{object?.title}</li>);
                                return professionals_data;
                            })}

                        </ul>
                        {
                            professionals.length === 0 ? (
                                <div class="no_result_found showMsg">
                                    <b>{t('No result found')}</b>
                                </div>
                            ) : (
                                <div>
                                    <b></b>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
            : ''
        }

        {(props?.version2 && props?.version2 == 'version2') ?
            <div class="filter-sec col-1 all_btn version_2 search_by_name">
                <button onClick={redirect_tosearch_page2} class="searchfilterbtn">Αναζήτηση</button>
            </div>

            : ''
        }


        {(props?.version3 && props?.version3 == 'version3') ?

            <div class="filter-container_version3" data-type="search_by_all">
                <div class="filter-sec col-xl-8 col-lg-8 col-md-12 search_by_info_all search_all" data-type="search_by_info">
                    <div class="filter-form-group " data-index="1">
                        <input type="hidden" value={props?.lan} id="current_lan" name="current_lan" />

                        <input class="tradeInputData filter-form-group-dropdown" onKeyUp={filterTradeData} onChange={e => setSelectValue2(e.target.value)} value={select_value2} type="text" placeholder={t('Trades')} autocomplete="off" />

                        <div class="filter-select-arrow_wrapper filter-select-arrow_wrapper1"
                            onClick={() => setToggle(!toggle)}
                        >
                            <span class="filter-select-arrow" onClick={open_dropDown1} ></span>
                        </div>


                        {toggle && (<div class="filter-search-result filter_1" >
                            <ul>
                                {trades_data.map(function (object, i) {

                                    return <li data-index="1" data-target="traderData" onClick={setInputValue} data-label={object.title} data-value={object.slug}>{t(object.title)}</li>
                                })}
                            </ul>

                            {
                                trades_data.length === 0 ? (
                                    <div class="no_result_found showMsg">
                                        <b>{t('No result found')}</b>
                                    </div>
                                ) : (
                                    <div>
                                        <b></b>
                                    </div>
                                )
                            }
                        </div>
                        )}
                    </div>
                </div>
                <div class="filter-sec col-xl-8 col-lg-8 col-md-12 search_by_info_all search_all" data-type="search_by_info">
                    <div class="filter-form-group" data-index="0">
                        <input class="locationInputData filter-form-group-dropdown TEST" onKeyUp={filterLocationData} onChange={e => setSelectValue1(e.target.value)} value={select_value1} type="text" placeholder={t('Locations')} autocomplete="off" />
                        <div class="filter-select-arrow_wrapper filter-select-arrow_wrapper2"
                            // onClick={() => setToggle1(!toggle1)}
                            onClick={toggleLocationResultBox}
                        >
                            <span class="filter-select-arrow" onClick={open_dropDown2}></span>
                        </div>
                        {toggle1 && (<div class="filter-search-result filter_2">
                            <ul class="atica_child">

                                {(locations_data) ? locations_data.map(function (child_val, i) {

                                    if (child_val?.parent == 0) {

                                        var data = (<li class="rem_parent_location " data-index="0" onClick={setInputValue} data-label={child_val?.title} data-value={child_val?.slug}>{child_val?.title}</li>);
                                        return data;
                                    }
                                    //  console.log(child_val?.title);
                                    var data = (<li class="rem_child_location" data-index="0" onClick={setInputValue} data-label={child_val?.title} data-value={child_val?.slug}>{child_val?.title}</li>);
                                    return data;
                                }) : ""
                                }


                            </ul>

                            {
                                locations_data.length === 0 ? (
                                    <div class="no_result_found showMsg">
                                        <b>{t('No result found')}</b>
                                    </div>
                                ) : (
                                    <div>
                                        <b></b>
                                    </div>
                                )
                            }
                        </div>
                        )}
                    </div>
                </div>

                <div class="filter-sec col-xl-8 col-lg-8 col-md-12 search_by_Pname search_all" data-type="search_by_name">
                    <div class="filter-form-group" data-index="0">
                        <input class="traderInputData filter-form-group-dropdown" onKeyUp={filterTradersData} onChange={e => setSelectTrader(e.target.value)} value={selectTrader} type="text" placeholder={t('Ονομα επαγγελματία')} autocomplete="off" />
                        <div class="filter-search-result filter_2">
                            <ul class="atica_child ">

                                {/* {
                            console.log(professionals)
                        } */}
                                {professionals.map(function (object, i) {

                                    // var professionals_data = (<il>test</il>);
                                    var professionals_data = (<li class="rem_parent_location " onClick={setInputValue} data-index="2" data-label={object?.title} data-value={object?.slug}>{object?.title}</li>);
                                    return professionals_data;
                                })}

                            </ul>
                            {
                                professionals.length === 0 ? (
                                    <div class="no_result_found showMsg">
                                        <b>{t('No result found')}</b>
                                    </div>
                                ) : (
                                    <div>
                                        <b></b>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>

                <div class="filter-sec col-1 all_btn version_2 search_by_Pname">
                    <button onClick={redirect_tosearch_page2} class="searchfilterbtn">Αναζήτηση</button>
                </div>
                <div class="filter-sec col-1 all_btn version_1 search_by_info_all">
                    <button onClick={redirect_tosearch_page1} class="searchfilterbtn">Αναζήτηση</button>
                </div>
                <div class="ta_taggle_search">
                    <p onClick={toggle_search_fields} data-type="" class="ta_search_by_traders search_toggle_bar">
                        <span class="searchIconSVG">
                            <svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.71 34.01">
                                <g id="icons">
                                    <g>
                                        <path d="m27.37,8.11c-1.33-1.33-3.09-2.06-4.97-2.06s-3.64.73-4.97,2.06c-.49.49-.49,1.28,0,1.77.49.49,1.28.49,1.77,0,.85-.85,1.99-1.33,3.2-1.33s2.35.47,3.2,1.33c.24.24.56.37.88.37s.64-.12.88-.37c.49-.49.49-1.28,0-1.77Z"></path>
                                        <path d="m31.05,3.66c-2.44-2.44-5.64-3.66-8.84-3.66s-6.4,1.22-8.84,3.66c-4.28,4.28-4.81,10.88-1.59,15.73l-2.3,2.3-.35-.35c-.2-.2-.51-.2-.71,0L.29,29.47c-.39.39-.39,1.02,0,1.41l2.83,2.83c.39.39,1.02.39,1.41,0l8.13-8.13c.2-.2.2-.51,0-.71l-.35-.35,2.19-2.19c2.26,1.77,4.98,2.67,7.71,2.67,3.2,0,6.4-1.22,8.84-3.66,4.88-4.88,4.88-12.8,0-17.68Zm-2.83,14.85c-1.61,1.61-3.74,2.49-6.01,2.49s-4.4-.88-6.01-2.49-2.49-3.74-2.49-6.01.88-4.4,2.49-6.01c1.61-1.61,3.74-2.49,6.01-2.49s4.4.88,6.01,2.49,2.49,3.74,2.49,6.01-.88,4.4-2.49,6.01Z"></path>
                                    </g>
                                </g>
                            </svg>
                        </span>
                        {searchTypeText}
                    </p>
                </div></div>
            : ''
        }

    </div>);
}

export default OurComponent;